/**
 * Public /privacy page (C23).
 *
 * Placeholder policy text pending formal legal review (the page says so).
 * The non-negotiable requirement from the brief / PLAN.md §7 is satisfied:
 * a clear public contact path exists on the page.
 */
import Alert from "@mui/material/Alert";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { createFileRoute } from "@tanstack/react-router";

const CONTACT_EMAIL = "contact@records-monitor.example";

function PrivacyPage() {
  return (
    <Container maxWidth="md" sx={{ mt: 4 }}>
      <Stack spacing={3}>
        <Typography variant="h4" component="h1">
          Privacy Policy
        </Typography>

        <Alert severity="info">
          This policy is a working draft pending formal legal review. The authoritative version will
          replace this text before public launch.
        </Alert>

        <Typography variant="body1">
          Records Monitor indexes public records published by local governments. The records
          themselves are public information sourced from official government websites; we do not
          create them.
        </Typography>

        <Typography variant="body1">
          For account holders we store the minimum needed to operate the service: your email address
          (via Google Identity Platform), your saved searches, and your notification preferences. We
          do not sell personal data. Notification emails are sent through our transactional email
          provider solely to deliver the alerts you have configured.
        </Typography>

        <section aria-labelledby="privacy-contact-heading">
          <Typography id="privacy-contact-heading" variant="h5" component="h2" gutterBottom>
            Contact and data requests
          </Typography>
          <Typography variant="body1">
            To access or delete your account data, or to request removal of inadvertently-published
            private information from the index, email{" "}
            <Link href={`mailto:${CONTACT_EMAIL}`}>{CONTACT_EMAIL}</Link>. See our{" "}
            <Link href="/about">About</Link> page for our takedown policy.
          </Typography>
        </section>
      </Stack>
    </Container>
  );
}

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
});
